import { camelCase } from 'change-case'
import Measure from 'react-measure'
import { DefaultQueryClientProvider } from '@opallabs/higgs'
import { kuiperClassNames } from '@opallabs/kuiper'
import { getNestedProperty } from '@opallabs/lambda'
import {
  AssetAndCopy,
  BlueskyStandard,
  Document,
  FacebookReel,
  FacebookStandard,
  FacebookStory,
  InstagramCarousel,
  InstagramCarouselAppAd,
  InstagramCarouselLinkAd,
  InstagramExpandableStoryAd,
  InstagramImageOrVideoStoryAd,
  InstagramNativeStoryAd,
  InstagramStandard,
  InstagramReel,
  InstagramStory,
  LinkedInArticle,
  LinkedInDocument,
  RedditPromotedPost,
  SharepointDocument,
  SMS,
  SnapchatPhoto,
  ThreadsStandard,
  TikTokCarousel,
  TikTokVideo,
  TwitterGif,
  TwitterMoment,
  TwitterPageUpdate,
  TwitterRetweet,
  TwitterThread,
  TwitterTweet,
  TwitterVideo,
  YouTubeChannelUpdate,
  YouTubeShort,
} from '../Content'
import * as styles from './styles'

const contentMap = {
  all: {
    asset_and_copy: AssetAndCopy,
    document: Document,
  },
  bluesky: {
    bluesky_gif: BlueskyStandard,
    bluesky_standard: BlueskyStandard,
    bluesky_video: BlueskyStandard,
  },
  facebook: {
    facebook_story: FacebookStory,
    reel: FacebookReel,
    standard: FacebookStandard,
  },
  instagram: {
    instagram_carousel_ad: InstagramCarouselLinkAd,
    instagram_carousel_app_ad: InstagramCarouselAppAd,
    instagram_carousel: InstagramCarousel,
    expandable_story_link_ad: InstagramExpandableStoryAd,
    instagram_story: InstagramStory,
    native_story_link_ad: InstagramNativeStoryAd,
    photo: InstagramStandard,
    reel: InstagramReel,
    story_link_ad: InstagramImageOrVideoStoryAd,
    video: InstagramStandard,
  },
  linked_in: {
    document_post: LinkedInDocument,
    linkedin_article: LinkedInArticle,
  },
  reddit: {
    promoted_post: RedditPromotedPost,
  },
  sharepoint: {
    sharepoint_document: SharepointDocument,
  },
  sms_message: {
    sms: SMS,
  },
  snapchat: {
    photo: SnapchatPhoto,
  },
  threads: {
    standard: ThreadsStandard,
  },
  tiktok: {
    tiktok_carousel: TikTokCarousel,
    video: TikTokVideo,
  },
  twitter: {
    gif: TwitterGif,
    moment: TwitterMoment,
    page_update: TwitterPageUpdate,
    retweet: TwitterRetweet,
    standard: TwitterTweet,
    thread: TwitterThread,
    video: TwitterVideo,
  },
  you_tube: {
    youtube_short: YouTubeShort,
    channel_update: YouTubeChannelUpdate,
  },
}

export const matchPostType = (service, postType) =>
  getNestedProperty(contentMap, service, postType) ||
  getNestedProperty(contentMap, 'all', postType) ||
  null

export const onResize = ({ contentRect, readOnly, onDisplayChange }) => {
  if (readOnly) {
    if (!contentRect.entry) {
      return null
    }

    const height = contentRect.entry.height
    const width = contentRect.entry.width

    return onDisplayChange?.({ height, width })
  }

  return null
}

export const Post = (props) => {
  const { display, onDisplayChange, postType, readOnly, service } = props

  const PostRenderer = matchPostType(service, postType)

  if (PostRenderer === null) return null

  return (
    <DefaultQueryClientProvider>
      <Measure
        onResize={(contentRect) =>
          onResize({ contentRect, readOnly, onDisplayChange })
        }
      >
        {({ measureRef }) => (
          <section
            css={styles.post}
            ref={measureRef}
            className={kuiperClassNames('post')}
          >
            <PostRenderer {...props} display={camelCase(display)} />
          </section>
        )}
      </Measure>
    </DefaultQueryClientProvider>
  )
}
